import { gql } from 'graphql-request';
import {
  baseApi,
  select,
  insert,
  update,
  remove,
  afterInsert,
  afterUpdate,
  afterRemove,
} from './base';

import { standardType } from '../graphqlTypes';

const buildFilter = (payload = {}) => {
  const clauses = [];

  const addClause = (field, value) => {
    if (typeof value !== 'string' || value.trim() === '') return;
    const safeValue = value.replace(/"/g, '\\"');
    clauses.push(`${field}: {_ilike: "%${safeValue}%"}`);
  };

  ['id', 'code', 'label', 'region'].forEach((field) => addClause(field, payload[field]));

  return `{${clauses.join(',')}}`;
};

const standardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStandardFilter: select(builder, 'standard', standardType, false, {
      filter: (params) => buildFilter(params?.payload),
      order: `{updated_at: desc}`,
      cacheKey: (params) => params?.queryArgs?.cacheKey,
    }),
    getStandard: select(builder, 'standard', standardType, true),
    searchStandards: builder.query({
      query: ({ searchTerm = '', limit = 10, offset = 0 } = {}) => {
        const safeSearch = searchTerm.replace(/"/g, '\\"');
        const whereClause = safeSearch.length
          ? `_or: [{code: {_ilike: "%${safeSearch}%"}}, {label: {_ilike: "%${safeSearch}%"}}, {region: {_ilike: "%${safeSearch}%"}}]`
          : '';
        const where = whereClause ? `where: {${whereClause}}` : '';
        return {
          body: gql`
            query {
              standard(${where ? `${where},` : ''} order_by: {updated_at: desc}, limit: ${limit}, offset: ${offset}) ${standardType}
              standard_aggregate${where ? `(${where})` : ''} {
                aggregate {
                  count
                }
              }
            }
          `,
        };
      },
      transformResponse: (response) => ({
        items: response.standard,
        total: response.standard_aggregate.aggregate.count,
      }),
    }),
    insertStandard: insert(builder, 'standard', standardType, afterInsert('getStandardFilter')),
    insertStandards: insert(
      builder,
      'standard',
      `{returning ${standardType}}`,
      undefined,
      undefined,
      true
    ),
    updateStandard: update(builder, 'standard', standardType, afterUpdate('getStandardFilter')),
    removeStandard: remove(builder, 'standard', standardType, afterRemove('getStandardFilter')),
  }),
  overrideExisting: false,
});

export const {
  useGetStandardFilterQuery,
  useGetStandardQuery,
  useSearchStandardsQuery,
  useInsertStandardMutation,
  useInsertStandardsMutation,
  useUpdateStandardMutation,
  useRemoveStandardMutation,
} = standardApi;
